//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'StickerDecoration',
  components: {
    MdmStripe
  },
  props: {
    trend: {
      type: Object,
      required: true
    },
    size: {
      type: MdmStripe.props.size.type,
      default: MdmStripe.props.size.default,
      validator: MdmStripe.props.size.validator
    }
  }
};